import { Outlet, createFileRoute } from '@tanstack/react-router';

import { useSyncTenantFromParams } from '@/context/organization-context';

/**
 * Tenant layout (inside dashboard chrome). The org + client live in the URL and
 * are the source of truth for this tab's tenancy; we sync them into context so
 * the rest of the app (which reads useOrganization) keeps working unchanged.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId')({
  component: TenantLayout,
});

function TenantLayout() {
  const { orgId, clientId } = Route.useParams();
  useSyncTenantFromParams(orgId, clientId);
  return <Outlet />;
}
